import { useEffect } from "react";

/**
 * SectionInView Component
 * Observes a section and dispatches optra:section-in-view events when it comes into view
 */
export default function SectionInView({ id }) {
  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.dispatchEvent(new CustomEvent("optra:section-in-view", { 
            detail: { id } 
          }));
        }
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: 0.1 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [id]);

  return null;
}
